import { axiosRequest } from '../../service';
import { REACT_APP_VAM_CONTEXT_LITIGATION, REACT_APP_VAM_ENDPOINT } from '../../urls';

//Function to get Flagged Claims dropdown values 
export const fetchFlaggedClaimsOptions = async (setLoading) => {
  try {
    setLoading(true)
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/flag-list`);
    return response.data;
  } catch (error) {
    console.error("Error fetching flagged claims options:", error);
  } finally {
    setLoading(false)
  }
};

// Function to fetch the list of litigations for a claim
export const getLitigationLists = async (claimId, setLoading) => {
    try {
        setLoading(true);
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/litigationList/${claimId}`);
        return response.data;
    } catch (error) {
        setLoading(false);
        console.error("Error fetching litigation list for claim:", error);
    }
};

// Function to create a new litigation record
export const createClaimLitigation = async (litigationData, setLoading) => {
    try {
        setLoading(true);
        const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/litigation`, litigationData);
        return response.data;
    } catch (error) {
        setLoading(false);
        console.error("Error creating litigation record:", error);
    }
};
// Function to fetch the list of getLegalExpense for a claim
export const getLegalExpenses = async (claimId, setLoading) => {
    try {
        setLoading(true)
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/legal-expenses/${claimId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching legal expenses for claim:", error);
        setLoading(false)
    }
};
// Function to create a new legal expense record
export const createLegalExpense = async (legalExpenses, setLoading) => {
    try {
        setLoading(true)
        const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/legal-expenses`, legalExpenses); // Corrected endpoint
        return response.data;
    } catch (error) {
        console.error("Error creating legal expense record:", error);
        setLoading(false)
    }
};

// Function to flag a record (Fraud, Potential Litigation, Litigation))

export const updateFlag = async (flagDetails, setLoading) => {
    try {
        setLoading(true)
        const response = await axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/flag-claim`, flagDetails);
        return response.data;
    } catch (error) {
        console.error("Error updating flag:", error);
        setLoading(false)
    }
};

// Function to fetch flagged claim details
export const fetchFlagDetails = async (claimId, flagId, setLoading) => {
    try {
        setLoading(true)
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/flag-claim/${claimId}/${flagId}`);
        setLoading(false)
        return response.data;
    } catch (error) {
        console.error("Error fetching flagged claim details:", error);
        setLoading(false)
    }
};
// Function to fetch potential litigation details
export const fetchPotentialLitigationDetails = async (claimId) => {
    try {
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/potential-litigation/${claimId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
// Function to flag a record as potential litigation
export const updatePotentialLitigation = async (potentialLitigation) => {
    try {
        const response = await axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/potential-litigation`, potentialLitigation);
        return response.data;
    } catch (error) {
        throw error;
    }
};